// An interface to the service placed in Shell UI.
class tenantRegistryService {
	constructor(tenantService) {
		this.tenantService = tenantService;
	}

	getTenantInformation() {
		return this.tenantService.getTenant();
	}
}

angular
	.module('HomepageServices')
	.service('tenantRegistryService', ['tenantService', tenantRegistryService]);



// WEBPACK FOOTER //
// ./app/common/tenantRegistryService.js